exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sendtofunder .dropdown-container {\n  left: -120px;\n}\n", ""]);

// exports
